export const REPORT_PROGRESS_POLL_MILLIS = 1000;
export const REPORT_PROGRESS_POLL_INITIAL_DELAY_MILLIS = 0;
export const REPORT_PROGRESS_COMPLETE_PERCENT = 100;
export const REPORT_PROGRESS_INITIAL_PERCENT = 0;
export const REPORT_PROGRESS_EMPTY_COUNT = 0;
export const REPORT_PROGRESS_STAGE_PREFIX = 'REPORT_PROGRESS_';
export const REPORT_PROGRESS_DEFAULT_STAGE = 'VALIDATING';
export const REPORT_PROGRESS_UNAVAILABLE_AFTER_POLLS = 3;
export const REPORT_PROGRESS_UNAVAILABLE_STAGE = 'UNAVAILABLE';
export const REPORT_PROGRESS_COMPLETE_STAGE = 'COMPLETE';
export const REPORT_PROGRESS_FAILED_STAGE = 'FAILED';
export const REPORT_PROGRESS_GROUP_WAIT_STAGE = 'REPORT_DATA';
export const REPORT_PROGRESS_NUMBER_TYPE = 'number';
export const REPORT_PROGRESS_ID_PREFIX = 'report_';
export const REPORT_PROGRESS_ID_SEPARATOR = '_';
export const REPORT_PROGRESS_ID_RADIX = 36;
export const REPORT_PROGRESS_RANDOM_START = 2;
export const REPORT_PROGRESS_RANDOM_END = 12;



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-progress.constants.ts